import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { SubmitWhitelistAddressActionType } from 'data/actions'
import { WhitelistAddressFormType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import addAddressStep from './addAddressStep'
import disableStep from './disableStep'
import listAddressesStep from './listAddressesStep'
import setupStep from './setupStep'

const steps = {
  addaddress: addAddressStep,
  disable: disableStep,
  listaddresses: listAddressesStep,
  setup: setupStep
}

const submit = function* (action: SubmitWhitelistAddressActionType) {
  const form: WhitelistAddressFormType = yield select(selectors.whitelistAddress.getValues)

  yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', true))

  yield call(steps[action.payload.step], form)
}

export default function* twoFactorForm() {
  yield takeEvery(actionTypes.whitelistAddress.WHITELIST_SUBMIT, submit)
}
